import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: localStorage.getItem('token') ? '/home/index' : '/login'
    },
    {
      path: '/login',
      component: resolve => require(['../views/Login.vue'], resolve)
    },
    {
      path: '/producePrintPage',
      component: resolve => require(['../views/ProducePrintPage.vue'], resolve)
    },
    {
      path: '/produceReportPrintPage',
      component: resolve => require(['../views/ProduceReportPrintPage.vue'], resolve)
    },
    {
      path: '/buyOrderPrintPage',
      component: resolve => require(['../views/BuyOrderPrintPage.vue'], resolve)
    },
    {
      path: '/carouselPage',
      component: resolve => require(['../views/CarouselPage.vue'], resolve)
    },
    {
      path: '/home',
      component: resolve => require(['../views/Home.vue'], resolve),
      children: [
        {
          path: 'index',
          component: resolve => require(['../views/Index.vue'], resolve)
        },
        {
          path: 'productList',
          component: resolve => require(['../views/ProductList.vue'], resolve)
        },
        {
          path: 'materialList',
          component: resolve => require(['../views/MaterialList.vue'], resolve)
        },
        {
          path: 'customerOrderList',
          component: resolve => require(['../views/CustomerOrderList.vue'], resolve)
        },
        {
          path: 'buyList',
          component: resolve => require(['../views/BuyList.vue'], resolve)
        },
        {
          path: 'produceList',
          component: resolve => require(['../views/ProduceList.vue'], resolve)
        },
        {
          path: 'produceReportList',
          component: resolve => require(['../views/ProduceReportList.vue'], resolve)
        },
        {
          path: 'accountList',
          component: resolve => require(['../views/AccountList.vue'], resolve)
        },
        {
          path: 'setting',
          component: resolve => require(['../views/Setting.vue'], resolve)
        }
      ]
    },
    {
      path: '/404',
      component: resolve => require(['../views/NoFound.vue'], resolve)
    },
    {
      path: '*', // vue-router从上到下执行，找不到全部去404
      redirect: '/404'
    }
  ]
})
// router.beforeEach((to, from, next) => {
//   console.log(this.$store)
//   next()
// })
export default router
